import dayjs from "dayjs";
import { IExpense } from "../../@types";
import { getExpenseType } from "../invoice";
import { toSentenceCase } from "../toSentenceCase";
import { getDaySuffix } from "../invoice-list";
import { Navigate, useNavigate } from "react-router-dom";
import { formatCurrencyMoney, formatMoney } from "../format";

export const columns = [
  {
    key: "name",
    label: "Vendor/Title",
    width: 20,
  },
  {
    key: "category",
    label: "Expense Category",
    width: 20,
  },
  {
    key: "date",
    label: "Date",
    width: 20,
  },
  {
    key: "paymentMethod",
    label: "Payment Method",
    width: 20,
  },
  // {
  //   key: "type",
  //   label: "Type",
  //   width: 12,
  // },
  {
    key: "amount",
    label: "Amount",
    width: 20,
  },
];

export const renderExpensesData = (
  expenses: IExpense[],
  navigate: (path: string) => void,
) => {
  return expenses.map((expense: IExpense, index: number) => {
    const type = getExpenseType(expense.isBillable);
    return {
      createdAt: (
        <span
          onClick={() => navigate(`/expenses/${expense.id}/view`)}
          className="xl:text-violet-800"
        >
          {dayjs(expense.createdAt).format("MM/DD/YYYY")}
        </span>
      ),
      category: expense.category,
      companyId: expense.companyId,
      id: expense.id,
      name: (
        <a href={`/expenses/${expense.id}/view`} className="text-violet-800">
          {expense.name || expense.vendorName || "NA"}
        </a>
      ),
      paymentMethod: toSentenceCase(expense.paymentMethod?.toString() || ""),
      type: <span className="capitalize">{type}</span>,

      vendor: expense.name || expense.vendorName,
      amount: `${formatMoney(expense.amount, expense.currency)}`,
      date: `${getDaySuffix(dayjs(expense.createdAt).date())} ${dayjs(
        expense.createdAt,
      ).format("MMM")}, ${dayjs(expense.createdAt).format("YYYY")}`,
    };
  });
};
